export const FIND_SINGLE_ENCRYPT_PSEUDONYMS_REQUEST = 'FIND_SINGLE_ENCRYPT_PSEUDONYMS_REQUEST';

export const findSingleEncryptPseudonymsRequest = ({
     filter = [],
     sorting = { field: 'createdAt', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }) => ({
    type: FIND_SINGLE_ENCRYPT_PSEUDONYMS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
        pagination,
    }
});
